export default {"src":"/_next/static/media/tud-nmc-dark.f4d9da92.svg","height":52,"width":282,"blurWidth":0,"blurHeight":0};